import React from 'react';
import ReactDOM from 'react-dom/client'; // Atualizado para React 18
import { BrowserRouter } from 'react-router-dom'; // Importando o BrowserRouter
import App from './App';
import './index.css';

// Crie a raiz usando a API do React 18
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderize o App com o BrowserRouter
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
